module.exports = __webpack_public_path__ + "static/media/11233.1d3e1fa2.png";